import React from "react";
import styles from "./card.module.css"

const Card = ({ image }) => {
  return <img src={image} alt="card" className={styles.card}/>;
};

export { Card };
